import { type FC, type ReactElement, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { Link } from 'base-ui'

import { useGlobalConfigContext } from '../../../../global-config'
import { TENANT } from '../../../../tenant'
import { productAccessorGetPackageInsert } from '../../../model/productAccessor/productAccessorGetPackageInsert'
import { productAccessorIsMedicament } from '../../../model/productAccessor/productAccessorIsMedicament'
import { useProductPageContext } from '../../productPageContext'

export const ProductDescriptionCautionsDisclaimer: FC = () => {
  const { product } = useProductPageContext()
  const { tenant } = useGlobalConfigContext()
  // only show for medicaments
  if (!productAccessorIsMedicament(product) || tenant !== TENANT.COM) {
    return null
  }

  const packageInsert = productAccessorGetPackageInsert(product)

  const packageInsertLink = (text: ReactNode[]): ReactElement => {
    if (!packageInsert) {
      return <span>{text}</span>
    }

    return (
      <Link
        className="text-dark-primary-max"
        href={packageInsert.url}
        key={packageInsert.url}
        rel="noreferrer"
        target="_blank"
      >
        {text}
      </Link>
    )
  }

  return (
    <div className="mb-5 items-center rounded-m border border-dark-primary-min p-3.5 font-medium">
      <FormattedMessage
        id="productAdditonalInfos.label.disclaimer"
        values={{ packageInsertLink }}
      />
    </div>
  )
}
